/** Куда уводить, когда адрес возврата не наш. Дашборд — единственное безопасное «домой». */
const FALLBACK = '/dashboard';

/**
 * Адрес возврата принимается только свой: путь от корня и без второй косой черты. `//evil.com`
 * браузер читает как протокол-относительный адрес чужого хоста, а `href` у роутера, в отличие от
 * `to`, уходит на внешний адрес честно — то есть параметр из строки браузера иначе становится
 * открытым редиректом сразу после входа, когда человек меньше всего насторожен.
 */
const isOwnPath = (url: string) => url.startsWith('/') && !url.startsWith('//');

/**
 * Дописать метку «аккаунт только что создан» к адресу возврата.
 *
 * Адрес приезжает параметром `redirect` — то есть строкой, а не разобранным маршрутом, — и
 * собственные параметры у него уже есть (приглашение в сбор это `?invite=<код>`). Поэтому
 * разделитель выбирается по факту, а не ставится вслепую: `?` затирал бы приглашение.
 */
export const appendNewUserFlag = (url: string) => {
  const target = isOwnPath(url) ? url : FALLBACK;

  return `${target}${target.includes('?') ? '&' : '?'}newUser=true`;
};
